const ROOT = 'RATE_CARD_REVIEW_';

const actions = {
  PUBLISH_REQUEST: `${ROOT}PUBLISH_REQUEST`,
  PUBLISH_SUCCESS: `${ROOT}PUBLISH_SUCCESS`,
  PUBLISH_ERROR: `${ROOT}PUBLISH_ERROR`,
  /** Drops the publish outcome alone. `CLEAR_STORE` would take the validation with it. */
  CLEAR_PUBLISH_STATE: `${ROOT}CLEAR_PUBLISH_STATE`,

  // The pre-publish probe: the blockers publish would raise, asked for before Confirm is offered.
  LOAD_VALIDATION_REQUEST: `${ROOT}LOAD_VALIDATION_REQUEST`,
  LOAD_VALIDATION_SUCCESS: `${ROOT}LOAD_VALIDATION_SUCCESS`,
  LOAD_VALIDATION_ERROR: `${ROOT}LOAD_VALIDATION_ERROR`,

  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
